export let CIAM_AUTHENTICATION_STATUS = /*#__PURE__*/function (CIAM_AUTHENTICATION_STATUS) {
  CIAM_AUTHENTICATION_STATUS["AUTHENTICATED"] = "authenticated";
  CIAM_AUTHENTICATION_STATUS["ERROR"] = "error";
  CIAM_AUTHENTICATION_STATUS["LOADING"] = "loading";
  CIAM_AUTHENTICATION_STATUS["UNAUTHENTICATED"] = "unauthenticated";
  CIAM_AUTHENTICATION_STATUS["UNKNOWN"] = "unknown";
  return CIAM_AUTHENTICATION_STATUS;
}({});
export let CIAM_IDENTITY_LEVEL = /*#__PURE__*/function (CIAM_IDENTITY_LEVEL) {
  CIAM_IDENTITY_LEVEL["MH1"] = "MH1";
  CIAM_IDENTITY_LEVEL["MH2"] = "MH2";
  CIAM_IDENTITY_LEVEL["MH3"] = "MH3";
  CIAM_IDENTITY_LEVEL["MH4"] = "MH4";
  CIAM_IDENTITY_LEVEL["MH5"] = "MH5";
  CIAM_IDENTITY_LEVEL["MH6"] = "MH6";
  CIAM_IDENTITY_LEVEL["MH7"] = "MH7";
  return CIAM_IDENTITY_LEVEL;
}({});
export let CIAM_REDIRECT_PATH = /*#__PURE__*/function (CIAM_REDIRECT_PATH) {
  CIAM_REDIRECT_PATH["LOGIN"] = "/auth/login";
  CIAM_REDIRECT_PATH["LOGOUT"] = "/auth/logout";
  CIAM_REDIRECT_PATH["REGISTER"] = "/auth/register";
  return CIAM_REDIRECT_PATH;
}({});